function hasMessage(error: unknown): error is { message: string } {
  return typeof error === 'object' && error !== null && 'message' in error && typeof error.message === 'string';
}

function hasCause(error: unknown): error is { cause: unknown } {
  return typeof error === 'object' && error !== null && 'cause' in error;
}

export function toResourceError(error: unknown): Error {
  if (error instanceof Error) {
    return error;
  }

  const wrappedError = new Error(hasMessage(error) ? error.message : 'Request failed', { cause: error });
  wrappedError.name = 'AppResourceError';

  return wrappedError;
}

export function unwrapErrorCause(error: unknown): unknown {
  let currentError = error;
  const visitedErrors = new Set<unknown>();

  while (hasCause(currentError) && currentError.cause && !visitedErrors.has(currentError.cause)) {
    visitedErrors.add(currentError);
    currentError = currentError.cause;
  }

  return currentError;
}
